import loadable from '@loadable/component';

export const WhowhatwearSiteWrapper = loadable(
  () => import(/* webpackChunkName: "whowhatwear-site" */ './WhowhatwearSiteWrapper'),
);
